export function secondServise(n: number): number {
  return n * 1000;
}
